/**
 * Media library
 *
 * type = image | document
 */

// Open the media library
function openMediaLibrary(type, selectMedia) {
  if (!$('.media-library__wrapper').length) {
    createMediaLibrary(type, selectMedia);
  }
  requestMediaLibraryData(1);
}

// Close the media library
function closeMediaLibrary() {
  $('.media-library__overlay-wrapper').remove();
  $('body').removeClass('block-scroll');
}

// Get the data to send with the request
function getMediaLibraryRequestData(page) {
  var data = {
    type: getMediaLibraryType(),
    search: getMediaLibrarySearchTerm(),
    filter: getMediaLibraryFilters(),
    category: getMediaLibraryCategories(),
    order: getMediaLibraryOrder(),
    direction: getMediaLibraryDirection(),
    page: page || 1
  };
  return data;
}

// Request media library data
function requestMediaLibraryData(page) {
  if (app.mediaLibraryLoading) {
    return;
  }

  var data = getMediaLibraryRequestData(page);

  // console.log(data);

  $.ajax({
    url: '/admin/media/get',
    method: 'post',
    data: data,
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.mediaLibraryLoading = true;
      if ($('.media-library__wrapper .list-item__row--body').length) {
        $('.media-library__wrapper').addClass('requesting-data');
      } else {
        $('.list-items__wrapper').removeClass('list-items__wrapper--active');
        $('.list-items__notice').html(
          (data.type == 'image' ? 'Bilder' : 'Dokumente') + ' werden geladen...'
        );
        $('.list-items__notice').addClass('list-items__notice--active');
      }
    },
    success: function (response) {
      app.mediaLibraryLoading = false;
      $('.media-library__wrapper').addClass('media-library__wrapper--init');

      if (false) {
        // TODO createMediaLibraryTags(response);
      }
      if (!response || !response.listItems || !response.listItems.length) {
        $('.list-items__wrapper').removeClass('list-items__wrapper--active');
        $('.list-items__notice').html(
          'Keine ' +
            (data.type == 'image' ? 'Bilder' : 'Dokumente') +
            ' gefunden...'
        );
        $('.list-items__notice').addClass('list-items__notice--active');
      } else {
        $('.media-library__wrapper').removeClass('requesting-data');
        $('.list-items__wrapper').addClass('list-items__wrapper--active');
        $('.list-items__notice').removeClass('list-items__notice--active');
        updateMediaLibraryContent(response);
      }
      updateMediaLibraryPagination(response);
      initMediaLibraryCategories(response.categories || []);
    },
    error: function () {
      app.mediaLibraryLoading = false;
      ajaxError();
    }
  });
}

// Get the media library type
function getMediaLibraryType() {
  return $('.media-library__wrapper').attr('data-type') || 'image';
}

// Get media library filters
function getMediaLibraryFilters() {
  return $('.media-library__wrapper input[name="filter"]').val() || '';
}

// Get media library filters
function getMediaLibraryCategories() {
  return $('.media-library__wrapper input[name="category"]').val() || '';
}

// Get media library search term
function getMediaLibrarySearchTerm() {
  return $('.media-library__wrapper input[name="search"]').val() || '';
}

// Check if we are selecting media
function isSelectMediaEnabled() {
  return $('.media-library__overlay-wrapper').length > 0;
}

// Get the view
function getMediaLibraryView() {
  return localStorage.getItem('ml-view') || 'list';
}

// Set the view
function setMediaLibraryView(view) {
  view = view || getMediaLibraryView();
  localStorage.setItem('ml-view', view);
  $('.media-library__wrapper').attr('data-view', view);
  if (view == 'grid') {
    $('.media-library__wrapper').addClass('delay-title-opacity');
    setTimeout(function () {
      $('.media-library__wrapper').removeClass('delay-title-opacity');
    }, 300);
  }
}

// Get the sorting order
function getMediaLibraryOrder() {
  return $('.list-item__column--head[data-get-order][data-active="1"]').attr(
    'data-id'
  );
}

// Get the sorting direction
function getMediaLibraryDirection() {
  return $('.list-item__column--head[data-get-order][data-active="1"]').attr(
    'data-direction'
  );
}

// Set the sorting order
function setMediaLibraryOrder(item) {
  $('.list-item__column--head[data-get-order]').attr('data-active', '0');
  item.attr('data-active', 1);
  var currentDirection = $('.list-item__column--head[data-get-order]').attr(
    'data-direction'
  );
  $('.list-item__column--head[data-get-order]').attr(
    'data-direction',
    currentDirection == 'asc' ? 'desc' : 'asc'
  );
}
